module.exports = __webpack_public_path__ + "static/pharmacogx-353db1c2b8fda8d794db4b630608dbee.png";